import React from 'react';
import { MEDICAL_EXAM_CATEGORIES } from '../../../constants/medicalExamCategories';
import MedicalExamCatalogManager from '../medicalExams/MedicalExamCatalogManager';

/** Page Head Doctor — référentiel des analyses médicales. */
export default function HeadDoctorAnalysesPage() {
  return <MedicalExamCatalogManager categoryId={MEDICAL_EXAM_CATEGORIES.ANALYSIS.id} />;
}
